import { createSlice } from "@reduxjs/toolkit";
import {
  CHANGE_FONT,
  DISABLE_KEY_DOWN,
  FONT_HEADING_LOCK,
  FONT_DESCRIPTION_LOCK,
  GET_FONT_PAIRS,
  GET_FONT,
  IS_FONT_LOADING
} from "../types/font";
import { HAND_CURATED_PAIR ,MODEL_GENERATED_PAIR} from "../../constant";
const initialState = {
  currentFontPair: [],
  disableKeyDown: true,
  fontHeadingLock: false,
  fontDescriptionLock: false,
  fonts: [],
  fontPairs: HAND_CURATED_PAIR,
  allPairs:MODEL_GENERATED_PAIR,
  isFontLoading: false
};

const Font = createSlice({
  name: "font",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(CHANGE_FONT, (state, { payload }) => {
      if(typeof payload[0] === "undefined" || typeof payload[1] === "undefined") return;
      state.currentFontPair = payload;
    });
    builder.addCase(DISABLE_KEY_DOWN, (state, { payload }) => {
      state.disableKeyDown = payload;
    });
    builder.addCase(FONT_HEADING_LOCK, (state, { payload }) => {
      state.fontHeadingLock = payload;
    });
    builder.addCase(FONT_DESCRIPTION_LOCK, (state, { payload }) => {
      state.fontDescriptionLock = payload;
    });
    builder.addCase(GET_FONT_PAIRS, (state, { payload }) => {
      state.fontPairs = payload;
    });
    builder.addCase(GET_FONT, (state, { payload }) => {
      state.fonts = payload;
    });
    builder.addCase(IS_FONT_LOADING, (state, { payload }) => {
      state.isFontLoading = payload;
    });
  },
});

export const font = Font.reducer;
